import { AfterViewInit, Component, Directive, HostListener, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UiStyleToggleServiceService } from '../../services/theme.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})


export class HeaderComponent implements AfterViewInit, OnInit {

  ngOnInit() {
    this.detectHeader();
    this.navigation = this.result;
    $('.tdnn').click(function () {
      $(".moon").toggleClass('sun');
      $(".tdnn").toggleClass('day');
    });
    this.onChangeTheme();
  }

  location: any = '';
  navigation = [] as any;
  result = [
    // {
    //   "id": 5,
    //   "link": "/widgets",
    //   "linkText": "Widgets",
    //   "extraLink": false
    // },
    {
      "id": 1,
      "linkText": "Cloud Insights",
      "child": true,
      "submenu": [
        {
          "id": 1.1,
          "image": true,
          "link": "/cloud-insights/cloud-activity-dashboard",
          "linkText": "Cloud Activity Dashboard",
          "imagelink": "https://dummyimage.com/100X50/fff/aaa",
          "extraLink": false
        },
        {
          "id": 1.8,
          "image": true,
          "link": "/cloud-insights/threat-map-dashboard",
          "linkText": "Global Threat Map Dashboard",
          "imagelink": "https://dummyimage.com/100X50/fff/aaa",
          "extraLink": false
        },
        {
          "id": 1.2,
          "image": true,
          "link": "/cloud-insights/global-enforcement-dashboard",
          "linkText": "Global Enforcement Dashboard",
          "imagelink": "https://dummyimage.com/100X50/fff/aaa",
          "extraLink": false
        },
        {
          "id": 1.3,
          "image": true,
          "link": "/cloud-insights/global-internet-threats-insights",
          "linkText": "Global Internet Threat Insights",
          "imagelink": "https://dummyimage.com/100X50/fff/aaa",
          "extraLink": false
        },
        {
          "id": 1.4,
          "image": true,
          "link": "/cloud-insights/global-isp-incidents",
          "linkText": "Global ISP Incidents",
          "imagelink": "https://dummyimage.com/100X50/fff/aaa",
          "extraLink": false
        },        
        // {
        //   "id": 1.5,
        //   "image": true,
        //   "link": "/cloud-insights/cloud-application-dashboard",
        //   "linkText": "Cloud Application Dashboard",
        //   "imagelink": "https://dummyimage.com/100X50/fff/aaa",
        //   "extraLink": false
        // },
        {
          "id": 1.6,
          "image": true,
          "link": "/cloud-insights/encrypted-traffic-dashboard",
          "linkText": "Encrypted Traffic Dashboard",
          "imagelink": "https://dummyimage.com/100X50/fff/aaa",
          "extraLink": false
        },
        {
          "id": 1.7,
          "image": true,
          "link": "/cloud-insights/iot-dashboard",
          "linkText": "Internet of Things Dashboard",
          "imagelink": "https://dummyimage.com/100X50/fff/aaa",
          "extraLink": false
        },
        {
          "id": 1.8,
          "image": true,
          "link": "/cloud-insights/work-from-anywhere-dashboard",
          "linkText": "Work From Anywhere Trends",
          "imagelink": "https://dummyimage.com/100X50/fff/aaa",
          "extraLink": false
        }
      ]
    },
    {
      "id": 2,
      "linkText": "Tools",
      "child": true,
      "submenu": [
        {
          "id": 2.1,
          "image": false,
          "link": "/tool/url-check",
          "linkText": "URL Check",
          "extraLink": false
        },
        {
          "id": 2.2,
          "image": false,
          "link": "/tool/url-analysis",
          "linkText": "URL Analysis",
          "extraLink": false
        },
        // {
        //   "id": 2.3,
        //   "image": false,
        //   "link": "/files/file-check",
        //   "linkText": "File Check",
        //   "extraLink": false
        // }
      ]
    },
    // {
    //   "id": 2,
    //   "linkText": "URL",
    //   "child": true,
    //   "submenu": [
    //     {
    //       "id": 2.1,
    //       "image": false,
    //       "link": "/url/url-check",
    //       "linkText": "URL Check",
    //       "extraLink": false
    //     },
    //     {
    //       "id": 2.2,
    //       "image": false,
    //       "link": "/url/url-analysis",
    //       "linkText": "URL Analysis",
    //       "extraLink": false
    //     }
    //   ]
    // },
    // {
    //   "id": 2,
    //   "linkText": "Files",
    //   "child": true,
    //   "submenu": [
    //     {
    //       "id": 2.1,
    //       "image": false,
    //       "link": "/files/file-check",
    //       "linkText": "File Check",
    //       "extraLink": false
    //     },
    //     //   {
    //     //     "id": 2.2,
    //     //     "image": false,
    //     //     "link": "/files/file-analysis",
    //     //     "linkText": "File Analysis",
    //     //     "extraLink":false
    //     //   }
    //   ]
    // },
    //  {
    //     "id": 5,
    //     "link": "/threat/threat-library",
    //     "linkText": "Threat Library"
    // },
    {
      "id": 3,
      "linkText": "Threats",
      "child": true,
      "submenu": [
        {
          "id": 3.1,
          "image": false,
          "link": "/threat-library",
          "linkText": "Threat Library",
          "extraLink": false
        },
        {
          "id": 3.2,
          "image": false,
          "link": "/security-advisories",
          "linkText": "Security Advisories",
          "extraLink": false
        },
        // {
        //   "id": 3.2,
        //   "image": false,
        //   "link": "/threat/threat-categorization",
        //   "linkText": "Threat Categorization"
        // }
      ]
    },
    {
      "id": 4,
      "linkText": "Research",
      "child": true,
      "submenu": [
        // {
        //   "id": 4.1,
        //   "image": false,
        //   "link": "/security-advisories",
        //   "linkText": "Security Advisories",
        //   "extraLink": false
        // },
        {
          "id": 4.2,
          "image": false,
          "link": "/blogs", //
          "linkText": "Research Blogs",
          "extraLink": false
        },
        // {
        //   "id": 4.3,
        //   "image": false,
        //   "link": "/reports",
        //   "linkText": "Reports",
        //   "extraLink": false
        // }
      ]
    },
    // {
    //     "id": 5,
    //     "link": "/contact",
    //     "linkText": "Contact"
    // }
  ]



  windowScrolled: boolean | undefined;
  closeResult: string | undefined;
  navMethod: boolean = false;

  toggle2: boolean = true;
  constructor(private modalService: NgbModal, private themeService: UiStyleToggleServiceService) { }
  openSearch(content: any) {
    this.modalService.open(content, { centered: true, windowClass: 'search-modal' });
  }
  toggleNav() {
    this.navMethod = !this.navMethod;
  }
  // Canvas
  canvasMethod: boolean = false;
  toggleCanvas() {
    this.canvasMethod = !this.canvasMethod;
  }

  // Sticky Nav
  @HostListener("window:scroll", [])
  onWindowScroll() {
    this.windowScrolled = window.scrollY > 100;
  }

  //Mobile 
  open: boolean = false;
  trigger(item: { open: boolean; }) {
    item.open = !item.open;
  }
  // Add class on resize and onload window
  visible: boolean = false;
  breakpoint: number = 1199;
  public innerWidth: any;
  detectHeader() {
    this.innerWidth = window.innerWidth;
    this.visible = this.innerWidth >= this.breakpoint;
  }

  ngAfterViewInit(): void {
    // ($('.popup-youtube') as any).magnificPopup({
    //   type: 'iframe'
    // });
    // ($('.gallery-img-popup') as any).magnificPopup({
    //   type: 'image',
    //   gallery: {
    //     enabled: true,
    //   },
    //   mainClass: 'mfp-fade',
    // });
  }


  onChangeTheme() {
    this.toggle2 = !this.toggle2;
    this.themeService.toggle();
  }
}
